"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
//# sourceMappingURL=DocumentCardLogo.types.js.map